module.exports = __webpack_public_path__ + "661b9721504390c0cc181c62fd6c32c8.svg";